import React from "react";

export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Matchresultat',
    CORRECT_SCORE: 'Korrekt poäng',
    TOTAL_GOALS: 'Totala mål',
    DOUBLE_CHANCE: 'Dubbla chansen',
    UNDER_OVER: 'Över/under',
    UNDER_OVER_25: 'Ö/U 2,5',
    UNDER_OVER_25_INITIALS: 'Ö/U 2,5',
    UNDER_OVER_35_INITIALS: 'Ö/U 3,5',
    UNDER_OVER_15: 'Ö/U 1,5',
    ASIAN_HANDICAP: 'Asian Handicap',
    HANDICAP: '1x2 handikapp',
    HANDICAP_FIRST: '1x2 handikapp Hemma +1',
    HANDICAP_SECOND: '1x2 handikapp Borta +1',
    UNDER_OVER_05: 'Ö/U 0,5',
    UNDER_OVER_35: 'Ö/U 3,5',
    BOTH_TEAMS_SCORE: 'Bägge lagen tar poäng',
    BOTH_TEAMS_SCORE_INITIALS: 'BTTS',
    HOME_TEAM_GOALS: '{0} Team Goals',
    AWAY_TEAM_GOALS: '{1} Team Goals',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Match Betting Both Teams Score',
    WINNING_MARGIN: 'Vinstmarginal',
    CORRECT_SCORE_GROUP: 'Korrekt poänggrupp',
    HOME_TEAM_TO_SCORE: '{0} To Score',
    AWAY_TEAM_TO_SCORE: '{1} To Score',
    FIRST_TEAM_TO_SCORE: 'Första laget som tar poäng',
    LAST_TEAM_TO_SCORE: 'Sista laget som tar poäng',
    HALF_TIME_FULL_TIME: 'Halvtid Full tid',
    TEAM_SCORECAST: 'Team Scorecast',
    HALF_TIME_CORRECT_SCORE: 'Half Time Correct Score',
    HALF_TIME_RESULT: 'Half Time Result',
    FIRST_LAST_TO_SCORE: 'First / Last to Score',
    LAST: 'Last',
    FIRST: 'First',
    IN: 'in',
    LAST_THREE_GAMES: 'Last 3 Games',
    PREVIOUS: 'Föregående',
    EIGHT_RESULTS: '8 matcher',
    EIGHT_GAMES: '8 matcher',
    OVER_25: 'Över 2.5',
    UNDER_25: 'Under 2.5',
    OVER_35: 'Över 3.5',
    UNDER_35: 'Under 3.5',
    COVERED: 'Täckte',
    DID_NOT_COVER: 'Täckte inte',
    SPREAD: 'Spridning',
    TOTAL_POINTS_UNDER_OVER: 'Totala poäng under/över',
    TOTAL_POINTS_OVER_UNDER: 'Totala poäng Över/Under',
    MONEYLINE: 'Moneyline',
    TOTAL_POINTS_GROUP: 'Totala poäng grupp',
    MONEY_LINE_TOTAL_POINTS: 'Moneyline och totala poäng Ö/U',
    SPREAD_TOTAL_POINTS: 'Spridning och totala poäng Ö/U',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Argentina',
    'Belgium': 'Belgium',
    'Brazil': 'Brazil',
    'Colombia': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatia',
    'Czech Republic': 'Czech Republic',
    'Denmark': 'Denmark',
    'Egypt': 'Egypt',
    'England': 'England',
    'France': 'France',
    'Germany': 'Germany',
    'Greece': 'Greece',
    'Holland': 'Holland',
    'Iceland': 'Iceland',
    'Italy': 'Italy',
    'Mexico': 'Mexico',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'Republic of Ireland': 'Republic of Ireland',
    'Russia': 'Russia',
    'Spain': 'Spain',
    'Sweden': 'Sweden',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukraine',
    'Uruguay': 'Uruguay',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Turkey',
    'Netherlands': 'Netherlands',
    //Super league
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    // market specific words
    'DRAW': 'Oavgjort',
    'HD': '{0}/Oavgjort',
    'DA': 'Oavgjort/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'Under 2.5',
    'Over 2.5': 'Över 2.5',
    'Under 1.5': 'Under 1.5',
    'Over 1.5': 'Över 1.5',
    'Under': 'Under {0}',
    'Over': 'Över {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'Under 0.5',
    'Over 0.5': 'Över 0.5',
    'Under 3.5': 'Under 3.5',
    'Over 3.5': 'Över 3.5',
    'Both Score Yes': 'Ja',
    'Both Score No': 'Nej',
    'Home Not to Score': '{0} Not to Score',
    'Home Exactly 1': '{0} Exactly 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Not to Score',
    'Away Exactly 1': '{1} Exactly 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} to Win and both teams to score',
    'Home to Win to nil': '{0} to Win to nil',
    'Score draw': 'Score draw',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} to Win and both teams to score',
    'Away to Win to nil': '{1} to Win to nil',
    'Home Win By Exactly 1 Goal': '{0} Win By Exactly 1 Goal',
    'Home Win By Exactly 2 Goals': '{0} Win By Exactly 2 Goals',
    'Home Win By 3 or more goals': '{0} Win By 3 or more goals',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Draw With No Goals',
    'Draw With Goals': 'Draw With Goals',
    'Any Other': 'Any Other',
    'Home Not To Score': '{0} Not To Score',
    'Home To Score': '{0} To Score',
    'Away Not To Score': '{1} Not To Score',
    'Away To Score': '{1} To Score',
    'Home': '{0}',
    'No Goal': 'No Goal',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Draw',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Draw/{0}',
    'Draw/Draw': 'Draw/Draw',
    'Draw/Away': 'Draw/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Draw',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Other',
    'Draw': 'Draw',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'Under 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Över 249',
    //American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'Under 26',
    '25 And Under Short': 'Under 26',
    '51 And Over': 'Över 50',
    '51 And Over Short': 'Över 50',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Amerikansk',
    'Matchday': 'Matchdag',
    'Basketball': 'Basket',
    'Dogs': 'Hundar',
    'Motor Racing': 'Motortävlingar',
    'Results': 'Resultat',
    'Horses': 'Hästar',
    'Soccer': 'Fotboll',
    'US Football': 'Amerikansk fotboll',
    'Marble Racing': 'Kullopp',
    "Matchday_English": "Matchdag",
    "Matchday_Turkish": "Matchdag",
    "Matchday_Greek": "Matchdag",

    //Game SubTabs
    'Soccer_Euro': 'Euro',
    'Soccer_Soccer3_Super_League': 'Super League',
    'Soccer_Soccer3_Greek_League': 'Grekiska ligan',
    'Soccer_Super_League': 'Super League',
    'Soccer_World_Cup': 'Världscup',
    'Soccer_Soccer3_World_Cup': 'Världscup',
    'Horses_Sprints': 'Sprinterlopp',
    'Horses_Flats': 'Slätlopp',
    'Horses_Jumps': 'Hinderlöpning',
    'Basketball_US1': 'US1',
    'Basketball_US2': 'US2',
    'Basketball_Europe': 'Europa',
    'Dogs_Flats': 'Flats',
    'Dogs_City': 'Static Odds',
    'Motor_Racing_Stock_Cars': 'Stock-car',
    'Motor_Racing_Indy_Cars': 'Indycar',
    'US_Football_NFLA': 'NFLA',
    'US_Football_Football': 'Amerikansk',
    'Marble_Racing_Marbles': 'Kulspel',
    'Marble_Racing_Marbles2': 'Sand',
    'Marble_Racing_Marbles_Euro': 'Euro Kulspel',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    "Matchday_English_Matchday_English": "Matchdag",
    "Matchday_Turkish_Matchday_Turkish": "Matchdag",
    "Matchday_Greek_Matchday_Greek": "Matchdag",

    //Racing
    FORECAST: 'Forecast',
    TRICAST: 'Tricast',
    REVERSE_FORECAST: 'Kombination forecast',
    REVERSE_TRICAST: 'Kombination tricast',
    FIRST_ST: '1',
    SECOND_ND: '2',
    THIRD_RD: '3',
    RD: ':e',
    ST: ':a',
    ND: ':a',
    ANY: 'Vilken som',
    TO_WIN: 'Vinst',
    RACE_CARD: 'LOPPKORT',
    EACH_WAY: 'Vinnare och plats (Each-way)',
    EW: 'E/W',
    FORECAST_TRICAST: 'Forecast/Tricast',
    EACH_WAY_ODDS_PLACE: 'E/W {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'E/W {0} 1-2-3',
    EXPAND_ALL: 'Expand Markets',
    COLLAPSE_ALL: 'Collapse Markets',
    NUMBER: 'Nummer',
    SORT_BY: 'Sortera efter',
    BET_SLIP: 'Insatskvitto',
    CLOSE_BET_SLIP: 'Stäng',
    CLOSE_SLIP: 'Stäng',
    PLACED_BETS: 'Gjord satsning',
    SETTLED_BETS: 'Betald',
    SLIP: 'Kvitto',
    OPEN_BETS: 'Öppen',
    CLEAR_SELECTIONS: 'Rensa val',
    ADD_TO_BET_SLIP: 'Lägg till på insatskvitto',
    NO_BETS: 'Inga vad',
    COMBINATION_TRICAST: 'Combination Tricast',
    COMBINATION_FORECAST: 'Combination Forecast',
    TOTAL_STAKE: 'Totalinsats',
    TOTAL_POTENTIAL_RETURNS: 'Totala möjliga vinster',
    N_A: 'Ej tillämpligt',
    PLACE_BETS: 'Gör satsningar',
    REMOVE_ALL: 'Ta bort alla',
    POT_RETURNS: 'Möjl. vinst',
    RETURNED: 'Vunnet:',
    REFUNDED: 'Vunnet',
    OK: 'OK',
    WIN_INITIAL: 'W',
    DRAW_INITIAL: 'D',
    LOSE_INITIAL: 'L',

    //Settings
    SETTINGS: 'Inställningar',
    LANGUAGE: 'Språk',
    LAYOUT: 'Layout',
    ODDS: 'Odds',
    EN_GB: 'English UK',
    DECIMAL: 'Decimal',
    FRACTIONAL: 'Del',
    AMERICAN: 'Amerikansk',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Meddelande',
    WARNING_NOTIFICATION: 'Varning',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Varning',
    INFO_NOTIFICATION: 'INFORMATION',
    SUCCESS_NOTIFICATION: 'Framgång',

    SELECTION_REMOVAL: 'Det här valet kommer att tas bort om  ',
    SECONDS: ' sekunder',
    SECOND: ' sekund',
    REMOVE_CLOSED_EVENTS: 'Ta bort stängda event',
    SET_VIDEO_ON_FUL_SCREEN: 'Set Video on Full Screen?',
    CANCEL: 'Avbryt',

    //Error codes
    INTERNAL_ERROR: 'Internt fel',
    OPEN_BETS_WARNING: 'Det gick inte att lägga till vissa eller alla öppna satsningar till spelkortet eftersom de är från längre bak i tiden.',
    '-32602': 'En eller flera insatser gjordes inte i tid.',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'Max. antal insatser på insatskvittot har nåtts. Ta bort eller gör insatser innan du lägger till nya.',

    '-20000': 'Cannot establish connection (Error Code: -20000)', //INIT_NOT_INVOKED
    '-20001': 'Cannot establish connection (Error Code: -20001)', //MISSING_SESSION_TOKEN
    '-20002': 'Too many requests (Error Code: -20002)', //Duplicate single shot invocation
    '-20003': 'Too many requests (Error Code: -20003)', //INVOCATION_FREQUENCY_THRESHOLD_BREACHED
    '-20004': 'Invalid Request (Error Code: -20004)', //A BmsServerAPI command was received, but the params are not compliant with Operator rules.
    '-10000': 'Invalid Request (Error Code: -10000)', //INVALID_SESSION_TOKEN
    '-10001': 'Invalid Request (Error Code: -10001)', //INBOUND_MESSAGE_QUEUE_FULL
    '-1000': 'Spelet har ställts in. Kontakta kundsupport.',
    '-999': 'Sessionen har gått ut.',
    '-998': 'Spelare har stängts av',
    '-997': 'Kommando ej tillåtet',
    '-996': 'Error processing request (Error Code: -996)', //Gaming System Error
    '-995': 'Error processing request (Error Code: -995)', //BMS Internal Error
    '-994': 'Anslutningen med servern tappades, ingen satsning gjord.',
    '-980': 'Error processing request (Error Code: -980)', //Error processing game command.
    '-979': 'Error processing request (Error Code: -979)', //Error on Json message sent by Virgo.
    '-978': 'Det finns inte tillräckligt med pengar för att utföra denna transaktion.',
    '-977': 'Spelkollen misslyckades.',
    '-976': 'Plånboksoperationen har tillfälligt blockerats.',
    '-975': 'Insatsgränsen har överstigits.',
    '-974': 'Förlustgränsen har överstigits.',
    '-973': 'Ingen gräns har satts.',
    '-972': 'Fel gällande Ansvarsfullt spelande.',
    '-971': 'Plånboksoperationen misslyckades.',
    '-970': 'Plånbokstransaktionen har nekats.',
    '-969': 'Fel vid kommunikation med plånboken.',
    '-968': 'Plånbokstransaktionsfel.',
    '-967': 'Misslyckad autentisering.',
    '-966': 'Tröskeln för högvinst har överskridits.',
    '-965': 'Ogiltiga parametrar har passerats.',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'En eller flera insatser är inte giltiga. Lägsta insats: {0}, Högsta insats: {1}. Fixa detta innan du gör din insats.',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'En eller fler insatsers möjliga vinster överskrider högsta utbetalningen på {0}. Fixa detta innan du gör din insats.',
    BET_NON_DIVISIBLE_MESSAGE: 'Ett eller flera insatser är inte delbara med {0}. Åtgärda detta innan du gör din insats.',
    SINGLE_BET_COMMIT_MESSAGE: 'Du kan inte göra flera enskilda satsningar',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'Insatsen du gör är över {0}.',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Är det här OK',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: 'Högsta antalet på {0} har satsats. Välj ett annat event',

    //SIMPLIFIED UI
    TOTAL_BETS: 'TOTALINSATS:',
    PLACE_YOUR_BETS: 'Gör dina insatser',
    RACE_START: 'Race Start',
    RACE_START_TIME: 'Start Time',
    BET_SUMMARY: 'Insatssammanfattning',
    NO_BETS_RESUME: 'Inga insatser har gjorts för detta event',
    LIVE: 'LIVE',
    RACERS: 'Deltagare',
    SELECTION: 'Val',
    DATE_LOCATION: 'Event',
    STAKE: 'Insats',
    BET_TYPE_STAKE: 'Satsningstyp/Insats',
    POTENTIAL_RETURNS: 'Möjl. vinst',
    BET_HISTORY: 'Insatshistorik',
    BET_HISTORY_LABEL: 'För mer historik, klicka på knappen för insatshistorik',
    FILTER_WINS: 'Filtrera vinster',
    NEXT_RACE: 'Nästa lopp',
    WIN: 'Vinst',
    PLACE: 'Placering',
    SHOW: 'Visning',
    EXACTA: 'Forecast',
    TRIFECTA: 'Tricast',
    NO_WIN: 'INGEN VINST',
    WON: 'VUNNET',
    LOST: 'FÖRLUST',
    CURRENT_RACE: 'Aktuellt lopp',
    BOX: 'BOX',
    TO: 'till',
    PAYS: 'betalar',
    TRIFECTA_BOX: 'combination tricast',
    EXACTA_BOX: 'combination forecast',
    FINISH_YOUR_BETS: 'Avsluta dina insatser',
    SELECT_YOUR_BET_BELOW: 'Välj din insats nedan',
    BET: 'insats',
    REMOVED: 'har tagits bort',
    RESULT: 'Resultat',
    GOALS: 'Mål',
    NO_MORE_BETS: 'Inga fler insatser',
    EVENT_LIVE_MSG_LINE_1: 'Aktuellt event live',
    EVENT_LIVE_MSG_LINE_2: 'Välj från framtida ',
    EVENT_LIVE_MSG_LINE_3: 'Event ovan',
    NO_FUTURE_EVENTS: 'Läser in',
    AUTHENTICATION_REQUIRED: 'Logga in för att fortsätta',
    GAME_DISABLED: 'Spel inaktiverat',
    GAME_DISABLED_MESSAGE: 'Kontakta kundsupport.',
    VOIDED: 'OGILTIG',
    HELP: 'Hjälp',
    LAST_RESULTS: 'Senaste resultat',
    NO_LAST_RESULTS: 'Inga senaste resultat',
    PREVIOUS_RESULTS: 'Tidigare resultat',
    OFFENSE_PREVIOUS_RESULTS: 'Offence Previous Results',
    DEFENSE_PREVIOUS_RESULTS: 'Defence Previous Results',
    NO_LUCK: 'NO LUCK',
    THIS_TIME: 'THIS TIME',
    LOOK_FOR_THE_NEXT: 'Håll utkik efter nästa',
    SCHEDULED_EVENT: 'schemalagt event',
    LOOK_FOR_THE: 'Håll utkik efter',
    NEXT_SCHEDULED: 'nästa schemalagda',
    EVENT: 'event',
    RETURNS: 'VINST',
    NEXT: 'Nästa',
    FUTURE: 'Framtida',
    PLAYING: 'Spelar',

    //MESSAGE BAR
    ON: 'på',
    MB_RACE_ON: 'on',
    MB_RACE_WIN: 'vinst',
    MB_RACE_PLACE: 'att placera',
    MB_RACE_SHOW: 'att visa',
    MB_RACE_TRIFECTA_BOX: 'combination tricast',
    MB_RACE_EXACTA_BOX: 'combination forecast',
    MB_RACE_EXACTA: 'forecast',
    MB_RACE_TRIFECTA: 'tricast',
    MB_FOOTBALL_ON: 'on',

    // DESKTOP UI
    ADVERTISING_SPACE: 'ADVERTISING SPACE',
    CLEAR_LAST: 'Rensa senaste',
    CLEAR_ALL: 'Rensa alla',
    ACTIVE_BETS: 'Aktiva satsningar',
    ONLY_SHOW_WINS: 'Bara flervägsspel',
    MORE: 'Mer',
    BETS: 'Insatser',
    LOADING: 'Läser in',
    BET_SELECTION_MESSAGE: 'Gör dina val genom att klicka på oddsen.',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'undo',
    CLEAR: 'clear',
    HISTORY: 'historik',

    MARKETS: 'Marknader',
    MAIN: 'Främsta',
    VS: 'vs',
    AT: '@',
    SCORE: 'poäng',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Detaljer',
    NO_GOALS: 'Inga mål',

    MAX_WINNINGS_REACHED: 'Max. antal vinster har nåtts',
    MAX_WINNINGS_REACHED_TEXT: 'Den nuvarande insatsen överskrider högsta utbetalningen på {0}. Högsta tillåtna insatsvärde för denna satsning är {1}.',
    NO_CONNECTION_TITLE: 'Anslutningen tappades',

    NO_CONNECTION_TITLE_TEXT: 'Anslutningen med servern tappades. Se till att du har en stabil nätverksuppkoppling och uppdatera sidan. Kontakta support om problemet kvarstår.',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Anslutning stängd, användare ansluten två gånger.',
    BET_CONFIRMED_TEXT:'none',
    TAX_NOTIFICATION_TEXT: 'none',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',
    //Horses Jumps
    'HorsesJumps': 'Inspired Downs',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Anslutningen tappades',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Uppdatera sidan och logga in.',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Din nuvarande webbläsare stöds inte. Använd en av följande webbläsare: Chrome, Firefox eller Safari.',
    'BROWSER_NOT_SUPPORTED': 'Webbläsare stöds inte',
    'DOWNLOAD_CHROME': 'Ladda ner Chrome',
    'DOWNLOAD_FIREFOX': 'Ladda ner Firefox',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': 'Över 219.5',
    'Under 219.5': 'Under 219.5',
    'Over 214.5': 'Över 214.5',
    'Under 214.5': 'Under 214.5',
    'Over 209.5': 'Över 209.5',
    'Under 209.5': 'Under 209.5',
    'Over 144.5': 'Över 144.5',
    'Under 144.5': 'Under 144.5',
    'Over 149.5': 'Över 149.5',
    'Under 149.5': 'Under 149.5',
    'Over 154.5': 'Över 154.5',
    'Under 154.5': 'Under 154.5',
    'Over 159.5': 'Över 159.5',
    'Under 159.5': 'Under 159.5',
    'Over 164.5': 'Över 164.5',
    'Under 164.5': 'Under 164.5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'Slutordning',
    'FORECAST_MARBLE': 'Topp 2',
    'TRICAST_MARBLE': 'Topp 3',
    'REVERSE_FORECAST_MARBLE': 'Topp 2 vilken ordning som helst',
    'REVERSE_TRICAST_MARBLE': 'Topp 3 vilken ordning som helst',
    'TO_WIN_MARBLE': 'Vinst',
    'PLACE_MARBLE': 'Placering',
    'SHOW_MARBLE': 'Visning',
    'MARBLE': 'Marble',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',

    //Header
    'BALANCE': 'Saldo',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Wins The Game',
    'Any': 'Vilken som',
    "BET_BOTH": "Satsa bägge",
    //Matchday
    "betSlip_Matchday_English": "Matchdag",
    "betSlip_Matchday_Turkish": "Matchdag",
    "betSlip_Matchday_Greek": "Matchdag",
    "betSlip_Soccer": "Fotboll",
    "betSlip_Horses": "Hästar",
    "betSlip_Basketball": "Basket",
    "betSlip_Dogs": "Hundar",
    "betSlip_Motor Racing": "Motortävlingar",
    "betSlip_US Football": "Amerikansk fotboll",
    "betSlip_Marble Racing": "Kullopp",
    "POS": "pos",
    "TEAM": "lag",
    "P": "p",
    "W": "w",
    "D": "d",
    "L": "l",
    "F": "f",
    "A": "a",
    "PTS": "png",
    "LEAGUE TABLE": "ligatabell",
    "TREND": "trend",

    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

    //Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Över/Under',
    UNDER_OVER_05_SHORT: "0.5",
    UNDER_OVER_15_SHORT: "1.5",
    UNDER_OVER_25_SHORT: "2.5",
    UNDER_OVER_35_SHORT: "3.5",
    UNDER_SHORT: "U",
    OVER_SHORT: "O",
    "FULL TIME": "FULL TID",
    "FT": "FT",
    "System": "SYSTEM",
    "x1": "(x1)",
    "Multiplier": "Repeat Bet",
    "Main markets": "HUVUDMARKNADER",
    "8RANDOM": "8 SLUMPMÄSSIGT",
    "8FAVS": "8 FAV",
    "QUICK_SELECT": "SNABBVAL",
    "UNDER": "UNDER",
    "OVER": "ÖVER",
    "UNDER_OVER_2_5": "Över/Under 2.5",
    "UNDER_OVER_3_5": "Över/Under 3.5",
    "MATCH_RESULT": "Matchresultat",
    "YES": "JA",
    "NO": "NEJ",
    "REALITY_CHECK_WARNING_YES": "Ja",
    "REALITY_CHECK_WARNING_NO": "Nej",
    "ACCUMULATOR": "Ackumulator",
    "+1G": "+1G",
    "Single": "Enkel",
    "Doubles": "Dubbel(s)",
    "Trebles": "Trippel(s)",
    "Four Folds": "4 satsningar",
    "Five Folds": "5 satsningar",
    "Six Folds": "6 satsningar",
    "Seven Folds": "7 satsningar",
    "Eight Folds": "8 satsningar",
    "MD": "MD{0}",
    "MATCH": "MATCH",
    "INVALID_ACCA": "Där val visas som markerade är din flerval begränsade",
    "INVALID_ODDS": "Oddsvärdet är för högt. Ändra dina val",
    "INVALID_ACCA_MORETHAN_8": "Mångsatsning får inte innehålla fler än åtta val från en enskild match",

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Ackumulatorboost',
    "Bonus_Info": " {0}% bonus",
    "+": "+",
    "Bonus_Value": "Inkl. {0} bonus",
    "ACCUMULATOR_INFO": 'Om din ackumulatorsatsning lyckas läggs en bonus på {0} %–{1} % till i din vinst. Bonusbeloppet beror på antalet val.',
    "BET_TYPE": 'Satsningstyp',
    "BOOST": 'Boost',
    "BOOST_PERCENTAGE": '{0}%',
    "BOOST_BONUS_START": '{0} eller fler valackumulator kommer att få en bonus',
    "BOOST_BONUS_UPGRADE": 'Lägg till ytterligare ett ackumulatorval för att få en extra bonus',
    "BOOST_BONUS_MAX": 'Du har högsta ackumulatorbonusen',
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Över {0}",
    "Short_Under": "Under {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Registrera dig eller logga in för att göra en satsning",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Avvisa",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Matchday Moroccan",
    "Matchday_Moroccan_Matchday_Moroccan": "Matchday Moroccan",
    "betSlip_Matchday_Moroccan": "Matchday Moroccan",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Matchdag",
    "Matchday_Belgium_Matchday_Belgium": "Matchdag",
    "betSlip_Matchday_Belgium": "Matchdag",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"EN PRESENT FÖR DIG",
    "Gift_for_You_Content": " Grattis! Du har kampanjerbjudanden att lösa in.",
    "View_Offers" : " VISA ERBJUDANDEN",
    "Do_Not_Show_MSG": " VISA INTE IGEN",
    "MY_OFFERS" : ' MINA ERBJUDANDEN',
    "SELECT_OFFER" : ' VÄLJ DITT ERBJUDANDE',
    "NO_OFFER" : ' DET FINNS INGA AKTIVA ERBJUDANDEN',
    "CHOOSE_BET": ' VÄLJ INSATS',
    "Opt_In": 'VÄLJ',
    "Key_Terms_Heading" :"VIKTIGA TERMER",
    "No_Thanks" : " NEJ TACK",
    "PROMO_BET": 'KAMPANJSATSNING',
    "Time_To_Bet": " TID FÖR ATT GÖRA INSATSER",
    "OPTED_IN_MSG": " TACK FÖR ATT DU VALT ATT DELTA",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Kricket",
    "Cricket_International": "Internationell",
    "betSlip_Cricket": "Kricket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Matchvinnare",
     "TOTAL_SIXES_IN_MATCH":"Total match 6:or",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Under 1.5",
     "TOTAL_FOUR_IN_MATCH":"Total match 4:or",
     "TOTAL_BOUNDARIES_IN_MATCH":"Total match gränser",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Totala Runs",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Runs off first delivery",
     "FIRST_TEAM_WICKET_LOST":"{0} Grind förlorad",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Första metod för avslagstyp",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Runs off första boll över/under",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Runs off första boll över/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Runs off första boll över/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Runs off första boll över/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Runs off första boll över/under",
     "Caught" : "Fångad",
     "Bowled":"Kastad",
     "LBW":"LBW",
     "No Wicket":"Ingen grind",
     "OverZeroPointFive": "Över 0.5",
     "UnderZeroPointFive": "Under 0.5",
     "OverOnePointFive": "Över 1.5",
     "UnderOnePointFive": "Under 1.5",
     "OverTwoPointFive": "Över 2.5",
     "UnderTwoPointFive": "Under 2.5",
     "OverThreePointFive": "Över 3.5",
     "UnderThreePointFive": "Under 3.5",
     "Yes": "Ja",
     "No":"Nej",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Över 14.5',
     UNDER_145: 'Under 14.5',
     DRAW_Cricket: "DRAW",
      //TENNIS
    TOTAL_POINTS:"Totala poäng",
    HANDICAP_TENNIS: "Handikapp",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "Internationell",
    betSlip_Tennis: "Tennis",
    "Win By 2 or 3": "Vinn med 3 eller färre poäng",
    "Win By 4 or 5": " Vinn med 4 eller 5 poäng",
    "Win By 6 or 7": "Vinn med 6 eller 7 poäng",
    "Tennis": "Tennis",
   //baseball
    WINNER : "VINNARE",
    TOTAL_HOME_RUNS_UNDER_OVER: "ANTAL HOME-RUNS Ö/U",
    TOTAL_HOME_RUNS:  "EXAKT ANTAL HOME-RUNS",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"VINNARE OCH ANTAL HOME-RUNS Ö/U 5,5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Vinnare och antal HR Ö/U 5,5",
    BATTER1_HOME_RUNS: "{0} HOME-RUNS",
    BATTER2_HOME_RUNS: "{1} HOME-RUNS",
    Baseball_HR_ShootOut_Legends: "Home-runs straffkast-legender",
    Baseball_HR_ShootOut_Legends_SHORT: "HR-straffkast",
    "Baseball": "Baseball",
    "betSlip_Baseball": "Baseball",
    "Player 1 AND OVER_5_5":"{0} och över 5,5",
    "Player 2 AND OVER_5_5":"{0} och över 5,5",
    "Player 1 AND UNDER_5_5":"{0} och under 5,5",
    "Player 2 AND UNDER_5_5":"{0} och under 5,5",
    "Draw AND OVER_5_5":"Oavgjort och över 5,5",
    "Draw AND UNDER_5_5":"Oavgjort och under 5,5",
    "HOME RUNS":"{0} HOME-RUNS"
};


// WEBPACK FOOTER //
// ./src/localization/sv_SE.js